
import { filterKey, Message } from '../state/ViewTypes';

export interface Node {
  elementId: string;
  id: string;
  name: string;
  label: string;
  url: string;
  date: string;
  specific_properties: SpecificNodeProperties;
}

export enum SummaryType {
  GENERAL = 'general',
  FACTS = 'facts',
  LAW = 'law',
  CONCLUSION = 'conclusion',
}

export type SpecificNodeProperties = {
  appno?: string;
  country?: filterKey[];
  importance?: filterKey;
  chambertype?: filterKey;
  judgementdate?: string;
  description?: string;
  separateopinion?: boolean;
  keywords?: string[];
  violation?: string;
  nonviolation?: string;
};

export type Slice<T> = {
  data: T;
  current_page: number;
  current_page_elements: number;
  total_pages: number;
  total_elements: number;
  page_size: number;
};

export interface Relationship {
  elementId: string;
  startNodeElementId: string;
  endNodeElementId: string;
  type: string;
  properties: {
    weight: number;
  };
}

export type GraphType = {
  nodes: Node[];
  edges: Relationship[];
}

export interface ResourceSection {
  id: string;
  name: string;
}

export interface Resource {
  id: string;
  name: string;
  subheader: string;
  description: string;
}

export interface ResponseQuery {
  conversationId: string;
  history: Message[];
  contextIds: string[];
}

export interface File {
  docname: string;
  id: string;
  summary: string;
  body: string;
}
